import { render } from "./IsoVoyageDetail.vue?vue&type=template&id=1745c0e8"
import script from "./IsoVoyageDetail.vue?vue&type=script&lang=js"
export * from "./IsoVoyageDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__